module.exports = __webpack_public_path__ + "static/media/Akemi_6210.213cfa24.jpg";